import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';
import { Cluster } from '../../sections/types/Cluster';

export interface IShareClusterToTenantSitesParams {
    clusterId: string;
}

export interface IShareClusterToTenantSitesResult extends IResult {
  success?: {
    cluster: Cluster;
};
  error?: BaasEdgePoolError;
}

export class ShareClusterToTenantSitesRequest extends Request<IShareClusterToTenantSitesParams, IShareClusterToTenantSitesResult> {
  constructor(params: IShareClusterToTenantSitesParams) {
    super('shareCluster', params);
  }
}
